type stringCutType = 'center' | 'end'

export const useString = () => {
    const shortCutString = (str: string, length: number = 3, cutString: stringCutType = 'center') => {
        if (str?.length / 2 - 2 < length) return str
        if (str?.length > 6) {
            if (cutString === 'center') {
                return str.slice(0, length ?? 3) + '...' + str.slice(length ? length * -1 : -3)
            } else {
                return str.slice(0, length * 2 ?? 6) + '...'
            }
        } else {
            return str
        }
    }

    const splitImageQuery = (strArr: string[]) => {
        const result = strArr.map(item => item.split('?').at(0))

        return result
    }

    const isEmpty = (text?: string): boolean => {
        if (!text) return true
        else if (text?.length === 0) return true
        else return false
    }

    const isNotEmpty = (text?: string): boolean => {
        return !isEmpty(text)
    }

    return {shortCutString, splitImageQuery, isEmpty, isNotEmpty}
}
